module.exports = __webpack_public_path__ + "img/kr-product-agency-card4-2.2fc501b.png";